export default {
  title: {
    en: 'We want to make sure that we billed you correctly and the address is correct. ',
  },
  reviewAddress: {
    en: 'Review address',
  },
  closeButton: {
    en: 'Nevermind',
  },
  justCancel: {
    en: 'Just cancel my subscription',
  },
}
